import React, { useEffect, useRef } from 'react'
import {AiOutlineCopyrightCircle} from 'react-icons/ai'
import { Link } from 'react-router-dom'
const Footer = () => {
    const footerRef = useRef(null)
    useEffect(() => {
        const footerElement = footerRef.current
        if (!footerElement) return
        const update = () => {
            document.documentElement.style.setProperty('--footer-height', `${footerElement.offsetHeight}px`)
        }
        update()
        const observer = new ResizeObserver(update)
        observer.observe(footerElement)
        return () => observer.disconnect()
    }, [])
    return (
        <div ref={footerRef} className="fixed bottom-0 w-full h-12 flex flex-wrap items-center justify-between px-5 text-xs text-slate-300">
            <div className='ms-[80px] mt-5'>Version <span className='font-bold'>{process.env.REACT_APP_VERSION}</span></div>
            <div className='flex justify-center items-center gap-1 '> 
                <span className='mt-5'>ALL CopyRight </span> 
                <AiOutlineCopyrightCircle className='mt-[10px]' />
                <span className='mt-5'> <span><Link target='_blank' to={`https://4sharks.org`}>4SHARKS</Link> </span>FOR SOFTWARE SOLUTIONS</span>
            </div>
        </div>
    )
}

export default Footer
